@keyframes modal-backlayer-open {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

@keyframes modal-backlayer-close {
    from {
        opacity: 1;
    }
    to {
        opacity: 0;
    }
}

@keyframes modal-open {
    from {
        opacity: 0;
        transform: scale(0.5, 0);
    }
    to {
        opacity: 1;
        transform: scale(1, 1);
    }
}

@keyframes modal-close {
    from {
        opacity: 1;
        transform: scale(1, 1);
    }
    to {
        opacity: 0;
        transform: scale(0.5, 0);
    }
}

.modal-backlayer {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1000001;
    display: flex;
    align-items: flex-start;
    justify-content: center;

    animation-duration: var(--transition-duration);
    animation-fill-mode: forwards;
    animation-name: modal-backlayer-close;

    &.open {
        animation-name: modal-backlayer-open;

        & > .modal-container {
            transform-origin: top;
            animation-name: modal-open;
        }
    }
}

.modal-container {
    box-shadow: var(--box-shadow);
    display: inline-flex;
    flex-direction: column;
    position: relative;
    background: white;
    z-index: 1000002;
    margin-top: 10%;
    transform-origin: bottom;

    animation-name: modal-close;
    animation-duration: var(--transition-duration);
    animation-fill-mode: forwards;

    & > div:nth-of-type(2) {
        padding: 1rem;
        text-align: justify;
    }

    * {
        z-index: 101;
    }

    & > .modal-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 1rem;
        background: var(--cs-origin);
        color: var(--cs-text);

        & > h2 {
            font-weight: bold;
            margin: 0 16px 0 0;
            padding-bottom: 0;
            font-size: 1.5rem;
        }

        & > button {
            width: 1.5rem;
            height: 1.5rem;
            padding: 0;

            & > i {
                font-size: 1.5rem;
                color: var(--cs-text);
            }
        }
    }
}